import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  anchor: {
    textDecoration: 'none',
    marginLeft: '1rem',
  },
  biometryButton: {
    width: '190px',
    borderRadius: '6px',
    textTransform: 'none',
    padding: '8px 16px',
    fontWeight: 500,
  },
  biometryCard: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: '#333',
  },
  cardDescription: {
    fontSize: '14px',
    lineHeight: '1.5',
    marginBottom: theme.spacing(3),
    color: '#666',
  },
  radioFormControl: {
    width: '100%',
    marginBottom: theme.spacing(3),
  },
  radioGroup: {
    '& .MuiFormControlLabel-root': {
      marginBottom: theme.spacing(1),
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      padding: theme.spacing(1, 2),
      margin: theme.spacing(0.5, 0),
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
    },
  },
  radioOption: {
    margin: 0,
  },
  radioButton: {
    color: '#FFA500',
    outline: 'none',
    border: 'none',
    '&.Mui-checked': {
      color: '#FFA500',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  countdownText: {
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
    fontSize: '12px',
  },
  fullScreenContainer: {
    padding: theme.spacing(4),
    maxWidth: '1200px',
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  fullScreenPaper: {
    padding: theme.spacing(4, 6),
    maxWidth: '860px',
    width: '100%',
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  fullScreenTitle: {
    fontSize: '24px',
    fontWeight: 600,
    marginBottom: theme.spacing(3),
    color: '#333',
    lineHeight: '1.3',
  },
  fullScreenDescription: {
    fontSize: '16px',
    lineHeight: '1.5',
    marginBottom: theme.spacing(4),
    color: '#666',
  },
  fullScreenRadioGroup: {
    width: '100%',
    marginBottom: theme.spacing(4),
    '& .MuiFormGroup-root': {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    '& .MuiFormControlLabel-root': {
      margin: 0,
      width: '100%',
    },
  },
  fullScreenRadioOption: {
    margin: 0,
    width: '100%',
  },
fullScreenButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    maxWidth: '890px',
    margin: '0 auto',
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(7.5),
    gap: theme.spacing(1),
  },
  fullScreenSendButton: {
    backgroundColor: '#FFA500',
    borderRadius: '6px',
    textTransform: 'none',
    padding: theme.spacing(1.5, 3),
    fontSize: '16px',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#FF8C00',
    },
  },
  modal: {
    '& .MuiDialog-paper': {
      borderRadius: '12px',
      minWidth: '400px',
      maxWidth: '500px',
    },
  },
  modalTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#333',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: theme.spacing(1),
    borderBottom: '1px solid #e0e0e0',
  },
  closeButton: {
    color: '#666',
    padding: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  modalContent: {
    padding: theme.spacing(3, 3, 2, 3),
  },
  modalDescription: {
    fontSize: '14px',
    lineHeight: '1.5',
    color: '#666',
    marginBottom: theme.spacing(2),
  },
  modalButtons: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    '& .MuiButton-root': {
      borderRadius: '6px',
      textTransform: 'none',
      padding: theme.spacing(1.5, 4),
      fontSize: '14px',
      fontWeight: 500,
      width: '100%',
    },
  },
  clockIcon: {
    marginRight: theme.spacing(0.5),
    fontSize: '16px',
  },
  resendQuestion: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#333',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  resendButtonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  resendOptionButton: {
    width: '100%',
    borderRadius: '6px',
    textTransform: 'none',
    padding: theme.spacing(1.5),
    fontSize: '14px',
    fontWeight: 500,
    color: '#333 !important',
    backgroundColor: 'transparent !important',
  },
}))
